const BlueDiagArrow = () => {
   return <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.42764 3.375V5.14567H11.6024L3.375 13.3731L4.62692 14.625L12.8543 6.39759V9.57236H14.625V3.375H8.42764Z" fill="#2977EC" />
   </svg>;
}

export default BlueDiagArrow;